<template>
    <div class="vx-row">
        <div class="vx-col w-full">
            <vs-card class="cardx">
                <div slot="header">
                    <h3>Track AWB</h3>
                </div>
                <div class="vx-col lg:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">Order / Tracking Reference*</div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="id" v-on:keyup.enter="track"/>
                        </div>
                    </div>
                </div>
                    <vs-button color="primary" type="filled" @click="track">Search</vs-button>
                <br>
                <vs-divider>Tracking History</vs-divider>
                <vs-list v-if="!history.length">
                    <vs-list-item title="No tracking history found"></vs-list-item>
                </vs-list>
                <vs-list v-else>
                    <vs-list-item v-for="(data, index) in history" :key="index" :title="data.desc" :subtitle="data.date"></vs-list-item>
                </vs-list>
            </vs-card>
        </div>
    </div>
</template>

<script>
	export default {
		data(){
			return {
                isLoading: false,
                id: '',
                history: []
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            track() {
                if(!this.id) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: 'Insert order or tracking reference'
                    });

                    return false;
                }
                
                this.isLoading = true;
                this.$http.get(`master/awb/track/${this.id}`)
                .then(res => {
                    let data = [];

                    if(res.data.length && res.data[0].status != false) {
                        data = res.data;
                    }

                    this.history = data;

                    this.isLoading = false;
                })
                .catch(error => {
                    this.history = [];
                    this.handleError(error);
                })
            }
        },
	}
</script>
